"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var DateFormatterService = function DateFormatterService() {

    /**
    * Convert a number to HH:MM:SS string format
    */
    var toHHMMSS = function toHHMMSS(num) {
        var sec_num = parseInt(num * 3600, 10); // don't forget the second param
        var hours = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - hours * 3600) / 60);
        var seconds = sec_num - hours * 3600 - minutes * 60;

        if (hours < 10) {
            hours = "0" + hours;
        }
        if (minutes < 10) {
            minutes = "0" + minutes;
        }
        if (seconds < 10) {
            seconds = "0" + seconds;
        }
        return hours + ':' + minutes + ':' + seconds;
    };

    /**
    * Convert a number to HH:MM:SS string format
    */

    var fromHHMMSSToNumber = function fromHHMMSSToNumber(timeString) {
        var a = timeString;
        if (timeString.lastIndexOf('\+') > -1) {
            a = timeString.substr(0, timeString.lastIndexOf('\+')); // discard timezone offset
        }
        a = a.toString().split(":"); // split it at the colons
        var hours = +a[0] + +a[1] / 60 + +a[2] / 3600 ? +a[0] + +a[1] / 60 + +a[2] / 3600 : 0;
        return parseFloat(hours.toFixed(2));
    };

    return { toHHMMSS: toHHMMSS, fromHHMMSSToNumber: fromHHMMSSToNumber };
};

exports.default = DateFormatterService;


// WEBPACK FOOTER //
// ./client/app/common/services/dateFormatter.service.js